// supplement_routes records non-geographic insertion failures only after the
// loading point and every delivery have passed this truck's evening radius.
export function eveningPoolRadiusStatus(attempts = []) {
  const codes = attempts.map(attempt => attempt?.reason_code || "");
  const radiusFailures = ["evening_radius_exceeded", "evening_coordinates_missing"];
  const passed = codes.some(code => code && !radiusFailures.includes(code)
    && !["protected_truck", "unavailable", "no_active_truck"].includes(code));
  if (passed) return {
    label: "Dans le rayon",
    title: "Au dernier calcul, le chargement et toutes les livraisons respectaient le rayon configuré d’au moins un camion évalué. Les autres contraintes peuvent néanmoins empêcher l’ajout.",
  };
  if (codes.length && codes.every(code => code === "evening_radius_exceeded")) return {
    label: "Hors rayon",
    title: "Au dernier calcul, le chargement ou une livraison dépassait le rayon configuré de chaque camion évalué.",
  };
  return {
    label: "Non vérifiable",
    title: "Le dernier calcul ne permet pas de confirmer la compatibilité du rayon : coordonnées, paramètre ou évaluation indisponibles.",
  };
}
